import { BoxProps, ListItemButton, Typography } from '@mui/material'
import { Box } from '@mui/system'
import { AppBlack, AppGreen, AppTextDisabled, BorderColor } from 'appconstants/AppColors'
import { ReactComponent as CircleGrayCheck } from 'assets/circle_gray_check.svg'
import { ReactComponent as CircleGreenCheck } from 'assets/circle_green_check.svg'
import { StepModel } from 'models/LeadStateModel'

type StepProps = BoxProps & {
  data?: StepModel
  isLast?: boolean
  onItemClick: (data: StepModel) => void
}

export const Step: React.FC<StepProps> = ({ data, isLast, onItemClick, ...boxProps }) => {
  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        ...boxProps.sx,
      }}
    >
      <ListItemButton
        onClick={() => {
          if (data.status === 'completed' || data.status === 'inprogress') onItemClick(data)
        }}
        sx={{ p: 1.5, m: -1.5 }}
      >
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'row',
            alignItems: 'center',
          }}
        >
          {data.status === 'completed' || data.status === 'disabled' ? (
            <Box
              sx={{
                height: '40px',
                width: '40px',
                borderRadius: '20px',
                border: 1,
                alignContent: 'center',
                alignItems: 'center',
                justifyContent: 'center',
                textAlign: 'center',
                fontSize: '15px',
                fontWeight: '500',
                display: 'flex',
                color: data.status === 'completed' ? AppGreen : AppTextDisabled,
              }}
            >
              {data.status === 'completed' ? (
                <CircleGreenCheck
                  style={{
                    height: '30px',
                    width: '30px',
                  }}
                />
              ) : (
                <CircleGrayCheck
                  style={{
                    height: '30px',
                    width: '30px',
                  }}
                />
              )}
            </Box>
          ) : (
            <Box
              sx={{
                height: '40px',
                width: '40px',
                borderRadius: '20px',
                borderColor: 'red',
                border: 1,
                alignContent: 'center',
                alignItems: 'center',
                justifyContent: 'center',
                textAlign: 'center',
                borderStyle: data.status === 'inprogress' ? 'dashed' : 'normal',
                display: 'flex',
                color: data.status === 'inprogress' ? AppGreen : BorderColor,
              }}
            >
              <Typography
                sx={{
                  color: data.status === 'inprogress' ? AppBlack : '#696C74',
                  fontSize: '15px',
                  fontWeight: '500',
                }}
              >
                {data.order}
              </Typography>
            </Box>
          )}

          <Typography
            sx={{
              fontSize: '15px',
              fontWeight: data.status === 'inprogress' ? '500' : '400',
              ml: '16px',
              color: data.status === 'inprogress' ? AppBlack : '#696C74',
            }}
          >
            {data.label}
          </Typography>
        </Box>
      </ListItemButton>

      {isLast !== true && (
        <Box
          sx={{
            height: '20px',
            width: '1px',
            ml: '20px',
            alignContent: 'center',
            alignItems: 'center',
            justifyContent: 'center',
            border: 1,
            color: data.status === 'completed' ? AppGreen : BorderColor,
            borderStyle: data.status === 'completed' ? 'normal' : 'dashed',
          }}
        />
      )}
    </Box>
  )
}
